module.exports = __webpack_public_path__ + "img/202627_u_en.443d8a53.png";